import { render, staticRenderFns } from "./HonorarPeriodeModal.vue?vue&type=template&id=17136890"
import script from "./HonorarPeriodeModal.vue?vue&type=script&lang=js"
export * from "./HonorarPeriodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports